function NXUser({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4291_1250)">
        <path
          d="M21.653 22.6786C20.9632 20.5278 19.6083 18.6517 17.7837 17.3206C15.959 15.9896 13.7587 15.2724 11.5001 15.2724C9.24147 15.2724 7.04121 15.9896 5.21651 17.3206C3.39182 18.6517 2.03694 20.5278 1.34723 22.6786H21.653Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 15.2858C15.3398 15.2858 18.4527 12.173 18.4527 8.33312C18.4527 4.49327 15.3398 1.38046 11.5 1.38046C7.66012 1.38046 4.5473 4.49327 4.5473 8.33312C4.5473 12.173 7.66012 15.2858 11.5 15.2858Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7703 11.0232C13.7703 11.0232 13.1934 12.1583 11.5001 12.1583C9.80669 12.1583 9.2298 11.0232 9.2298 11.0232"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3267 7.00939C18.3111 7.00948 18.2956 7.00953 18.2802 7.00953C16.2592 7.00953 14.4448 6.12536 13.2026 4.72276C11.9604 6.1254 10.1459 7.00958 8.12498 7.00958C6.95143 7.00958 5.84749 6.71142 4.88483 6.18672C5.78929 3.3973 8.40903 1.38046 11.4999 1.38046C14.8871 1.38046 17.7085 3.80264 18.3267 7.00939Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4291_1250">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500076)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXUser;
